
import wx from 'weixin-js-sdk';
import Qrcode from 'vux/src/components/qrcode/index.vue'

import axios from 'axios';
export default {
methods:{
},
components: {
Qrcode,
},
mounted(){
var _this = this;
axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href)).then(response => {
this.weixindata = response.data;
wx.config({
debug: false,
appId: _this.weixindata.appId,
timestamp: _this.weixindata.timestamp,
nonceStr: _this.weixindata.noncestr,
signature: _this.weixindata.signature,
jsApiList: ['checkJsApi','scanQRCode','onMenuShareAppMessage','onMenuShareTimeline']
});
}).catch(function (error) {
console.log('error: ' +error)

})

wx.ready(function(){

wx.onMenuShareTimeline({
title: '这是一个测试的标题--分享到朋友圈',
link: 'http://front.wh.jinxin-fertility.com/index.html#/fenxiang',//域名必须和安全域名保持一致
imgUrl: 'http://front.wh.jinxin-fertility.com/daohang.jpg',//域名必须和安全域名保持一致
success: function () {

alert('分享到朋友圈成功');
},
cancel: function () {

alert('你没有分享到朋友圈');
}
});

/*        wx.onMenuShareAppMessage({
title:'这是萨博心宝测试的标题--分享给朋友',
link:'http://front.wh.jinxin-fertility.com/index.html#/fenxiang',//域名必须和安全域名保持一致
imgUrl:'http://front.wh.jinxin-fertility.com/daohang.jpg',//域名必须和安全域名保持一致
trigger:function (res) {

},
success: function (res) {
alert('分享给朋友成功');
},
cancel: function (res) {
alert('你没有分享给朋友');
},
});*/

});
}
}



// WEBPACK FOOTER //
// ./src/project/ceshi/fenxiang.vue